import React from 'react';
import { Link } from 'react-router-dom'; // Assuming you're using react-router for navigation
import IconCollection from '../../IconCollection/IconCollection';

const HeaderComponent = ({ matchStatus, setResetDataModal, setExpendPanel }) => {
  return (
    <div>
      <div className="max-w-[1512px] w-full px-6 mx-auto h-8 lg:h-12 flex justify-center items-center">
        <div className="w-full flex justify-between items-center">
          {/* Home Link */}
          <Link to="/" className="flex items-center gap-1">
            <IconCollection
              customClass="lg:max-w-[24px] max-w-[10px] w-full lg:h-[24px] h-[10px]"
              name="home-icon"
            />
            <p className="font-montserrat text-sm lg:text-lg text-[#4A4A4A]">
              Home
            </p>
          </Link>

          {/* Match Status */}
          <div className="flex items-center gap-5 ml-[20%]">
            {matchStatus === 'Waiting to start' && (
              <div className="text-[#DB5F66] font-bebas text-xs lg:text-base top-1 text-center left-4 right-0">
                Waiting to start
              </div>
            )}
            {matchStatus === 'pause' && (
              <div className="text-[#DB5F66] font-bebas text-xs lg:text-base top-1 text-center left-4 right-0">
                Pause
              </div>
            )}
            {matchStatus === 'liveEnd' && (
              <div className="text-[#DB5F66] font-bebas text-xs lg:text-base top-1 text-center left-4 right-0">
                Live End
              </div>
            )}
            {matchStatus === 'live' && (
              <>
                <div className="max-w-[100px] w-full h-[24px] rounded px-2 flex gap-2 justify-between items-center border-[1px] border-[#DB5F66]">
                  <p className="font-bebas text-sm text-[#DB5F66]">live</p>
                  <div className="w-2 h-2 bg-[#D54043] rounded-full"></div>
                </div>
                <div className="cursor-pointer font-bebas text-sm text-[#CCCCCC] absolute top-[4px] right-[20px]">
                  End
                </div>
              </>
            )}
          </div>

          {/* Reset and Minimize Buttons */}
          <div className="flex gap-2 lg:gap-10 justify-end max-w-[190px] lg:max-w-[400px] w-full">
            <button
              onClick={() => setResetDataModal(true)}
              className="flex items-center gap-1 lg:gap-2"
            >
              <IconCollection
                customClass="lg:max-w-[20px] max-w-[10.16px] w-full lg:h-[20px] h-[10.16px]"
                name="reset-icon"
              />
              <p className="text-[#7D7D7D] text-[10px] lg:text-base font-montserrat">
                Reset Score
              </p>
            </button>
            <button
              onClick={() => setExpendPanel(false)}
              className="flex gap-1 lg:gap-2 items-center"
            >
              <IconCollection
                customClass="lg:max-w-[24px] max-w-[10.16px] w-full lg:h-[24px] h-[10.16px]"
                name="eye-off-icon"
              />
              <p className="text-[#7D7D7D] text-[10px] lg:text-base font-montserrat">
                Minimize Header
              </p>
            </button>
          </div>
        </div>
      </div>

      {/* Divider */}
      <div className="w-full bg-[#CCCCCC] h-[1px]"></div>
    </div>
  );
};

export default HeaderComponent;
